























































import CartCheckbox from './checkbox.vue'
import { apiShoppingCartUpdateSku } from '@/api'
import { CartGoods, cartModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'
import { showSkuPicker } from '@/views/goods/exports'
import { submit } from '@/utils'

export default defineClassComponent<{
  item: CartGoods
}>(
  {
    components: {
      CartCheckbox,
    },
    props: ['item'],
  },
  ({ props }) =>
    class {
      cartModel = cartModelProvider.inject()

      handleSkuClick = () => {
        showSkuPicker({
          goodsId: props.item.goodsId,
          initialSkuId: props.item.skuId,
          initialBuyCount: props.item.buyCount,
          action: 'pure',
          callback: async goodsData => {
            await submit(async $ => {
              $.start()
              await apiShoppingCartUpdateSku({
                id: props.item.id,
                skuId: goodsData.selectedSku.skuId,
                quantity: goodsData.buyCount,
              })
              await this.cartModel.value.refresh()
              await $.success('操作成功')
            })
          },
        })
      }
    },
)
